import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface EventLinkDialogData {
  link: string;
  accessCode: string;
}

@Component({
  selector: 'app-event-link-dialog',
  templateUrl: './event-link-dialog.component.html',
  styleUrls: ['./event-link-dialog.component.scss']
})
export class EventLinkDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EventLinkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EventLinkDialogData
  ) { }

  ngOnInit(): void {
  }

  copyToClipboard(text, sender) {

    // Get the span
    if (sender.tagName == 'BUTTON') {
      sender = sender.childNodes[0];
    }

    const textBackup = sender.textContent;
    sender.textContent = 'Copied!';
    sender.parentElement.setAttribute('disabled', 'true');
    navigator.clipboard.writeText(text);
    setTimeout(() => {
      sender.textContent = textBackup;
      sender.parentElement.removeAttribute('disabled');
    }, 1500);

  }

}
